// extracted by css-extract-rspack-plugin
var _1 = "ICubBkHMmSUS5aBr";
var _2 = "Capf3AtIvu8a1MrF";
export { _1 as "galleryColumn", _2 as "galleryRow" }
// extracted by css-extract-rspack-plugin
var _1 = "ICubBkHMmSUS5aBr";
var _2 = "Capf3AtIvu8a1MrF";
export { _1 as "galleryColumn", _2 as "galleryRow" }
